import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import ModalNDA from './ModalNDA/index.vue'
import ModalAgreementOwner from './ModalAgreementOwner/index.vue'
import ModalFund from './ModalFund/index.vue'
import { Api, Toast } from './../../../services'

export default {
  name: 'projectDetails',
  components: {
    Header,
    Footer,
    ProgressHUD,
    ModalNDA,
    ModalAgreementOwner,
    ModalFund,
  },
  data() {
    return {
      data: null,
      userCountProject: 0,
      validationMessage: null,
    }
  },
  methods: {
    clickLiked(event) {
      if (this.data.isLike) {
        this.unLiked(this.data.project._id)
      } else {
        this.addLiked(this.data.project._id)
      }
    },

    async addLiked(projectId) {
      var response = await Api.addLiked(projectId)
      if (response.data) {
        this.data.isLike = true
        this.data.likesCount++
      } else {
        console.error('Something went wrong.')
      }
    },

    async unLiked(projectId) {
      var response = await Api.unLiked(projectId)
      if (response.data) {
        this.data.isLike = false
        this.data.likesCount--
      } else {
        console.error('Something went wrong.')
      }
    },

    async getProjectById() {
      var response = await Api.getProjectById(this.$route.params.id) 
      this.setData(response.data.results[0])
    },

    async getCountForProjectsById() {
      var response = await Api.getCountProjectsById(this.$route.params.id)
      this.userCountProject = response.data.results
    },

    async eSignNda(imgeSign) {
      try {
        await Api.setProjectSignatureForNda(this.$route.params.id, imgeSign)
        await this.getProjectById()
        await this.getCountForProjectsById()
      } catch (error) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    },

    async acceptAgreementOwner() {
      try {
        await Api.setProjectSignatureForAgree(this.$route.params.id)
        await this.getProjectById()
        await this.getCountForProjectsById()
      } catch (error) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    },

    accept() {
      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: 'Not implemented.',
      })
    },

    setData(data) {
      this.data = data
      try {
        this.data.project.businessPlan = JSON.parse(
          this.data.project.businessPlan
        )
      } catch (error) {
        this.data.project.businessPlan = {
          definition: '',
          marketPlan1: '',
          operation: '',
          marketPlan2: '',
          pci: '',
          financial: '',
        }
      }
    },
  },
  async created() {
    try {
      await this.getProjectById()
      await this.getCountForProjectsById()
    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {
    $('.modal').modal()
    $('select').material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetails.component.js